// Legal content per language.
// EN is the source. Other languages fall back to EN if their file is missing.
import en from "./en";

const REGISTRY = {
  en,
};

// Lazy registration helper — translation files are loaded once and cached.
const lazyLangs = ["fr", "de", "es", "it", "pt", "ar", "ja", "ru", "zh"];

export function getLegalContent(lang) {
  if (REGISTRY[lang]) return REGISTRY[lang];
  if (!lazyLangs.includes(lang)) return en;
  try {
    // eslint-disable-next-line global-require
    const mod = require(`./${lang}.js`).default;
    REGISTRY[lang] = mod;
    return mod;
  } catch (e) {
    return en;
  }
}

export default getLegalContent;
